import { z } from "zod";

/**
 * Schema de validação para clientes
 * Usado em páginas CRUD de clients
 */
export const clientSchema = z.object({
	name: z.string().min(1, "Nome é obrigatório").max(255, "Nome muito longo"),

	email: z.string().email("Email inválido").optional().or(z.literal("")),

	phone: z
		.string()
		.max(20, "Telefone muito longo")
		.optional()
		.or(z.literal("")),

	cnpj: z.string().max(18, "CNPJ inválido").optional().or(z.literal("")),

	address: z
		.string()
		.max(500, "Endereço muito longo")
		.optional()
		.or(z.literal("")),
});
